import React from 'react'

import RecipeDifficultyIndicator from '../RecipeDifficultyIndicator'
import PricePerPortionBadge from '../PricePerPortionBadge'

import Styled from './RecipeClassification.styled'

const RecipeClassification = ({
  className,
  pricePerPortionTag,
  difficulty,
  nutritionalRatingScores,
}) => {
  return (
    <Styled className={className}>
      {pricePerPortionTag?.level && pricePerPortionTag?.currency ? (
        <Styled.item key="price-per-portion" href="#price-per-portion" as="a">
          <PricePerPortionBadge
            level={pricePerPortionTag.level}
            currency={pricePerPortionTag.currency}
            label={pricePerPortionTag.label}
            isFull
          />
        </Styled.item>
      ) : null}

      {typeof difficulty !== 'undefined' ? (
        <Styled.item key="difficulty">
          <RecipeDifficultyIndicator
            difficulty={difficulty}
            variant={'transparent'}
            direction={'vertical'}
          />
        </Styled.item>
      ) : null}

      {nutritionalRatingScores?.length > 0
        ? nutritionalRatingScores.map((score) => (
            <Styled.item key={score.id} href="#scores" as="a">
              <Styled.score
                src={score.vectorImageUrl}
                alt={score.label}
                title={score.label}
              />
            </Styled.item>
          ))
        : null}
    </Styled>
  )
}

export default RecipeClassification
